// extracted by mini-css-extract-plugin
var _1 = "ApplicantDocumentChecklistHead-moduletitle__xRfDs";
export { _1 as "title" }
